import { forwardRef, useMemo } from 'react';

import { useSwingFoundationParameters } from '@hooks';
import { useTranslate } from '@i18n';
import { useSwingThreadMessages } from '@queries';

import { SwingThreadProps, SwingThread } from '../../SwingThread';

type SwingThreadRendererProps = Omit<SwingThreadProps, 'options'> & {
    activePosition: number;
    visible: boolean;
    activeUserId: string;
};

export const SwingThreadRenderer = forwardRef<HTMLDivElement, SwingThreadRendererProps>(
    (
        {
            swingUuid,
            currentUserId,
            threadId,
            title,
            nodeId,
            fromFrame,
            activePosition,
            visible,
            onClose,
            activeUserId,
        },
        ref,
    ) => {
        const { data: swingThreads } = useSwingThreadMessages(threadId!);
        const params = useSwingFoundationParameters(activePosition);
        const t = useTranslate();
        const options = useMemo(
            () => params?.map(({ i18n, id }) => ({ label: t(i18n ?? '-'), value: id })),
            [params, t],
        );
        if (!visible) {
            return;
        }
        return (
            <SwingThread
                swingUuid={swingUuid}
                activeUserId={activeUserId}
                currentUserId={currentUserId}
                ref={ref}
                threadId={threadId}
                title={title}
                nodeId={nodeId}
                options={options || []}
                messages={swingThreads}
                fromFrame={fromFrame}
                onClose={onClose}
            />
        );
    },
);
